import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  input,
  HostBinding,
  Signal,
  computed
} from '@angular/core';
import { provideTranslationScope, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { Duration, intervalToDuration } from 'date-fns';

@Component({
  // eslint-disable-next-line @angular/component-selector
  selector: 'time[app-duration]',
  styleUrl: './duration.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslationPipeModule
  ],
  templateUrl: './duration.component.html',
  providers: [ provideTranslationScope('shared/duration') ]
})
export class ProjectDurationComponent {
  public readonly startDate: InputSignal<Date | string | null>
    = input<Date | string | null>(null);

  public readonly endDate: InputSignal<Date | string | null>
    = input<Date | string | null>(null);

  public readonly durationInput: InputSignal<Duration | undefined>
    = input<Duration | undefined>();

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  protected readonly computedDuration: Signal<Duration | undefined> = computed(() => {
    const explicit: Duration | undefined = this.durationInput();

    if (explicit) return explicit;

    const rawStart: string | Date | null = this.startDate();
    const rawEnd: string | Date | null = this.endDate();

    if (!rawStart || !rawEnd) return;

    const start: Date
      = rawStart instanceof Date ? rawStart : new Date(rawStart);
    const end: Date
      = rawEnd instanceof Date ? rawEnd : new Date(rawEnd);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()))
      return;

    start.setHours(0);
    end.setHours(0);

    return intervalToDuration({ start, end });
  });

  @HostBinding('class')
  protected class: string = 'mat-label-medium';
}
